import { InjectionToken } from '@angular/core';
import { IErrorMessages } from './error-messages.interface';

export const ErrorMessages = new InjectionToken<IErrorMessages>(
  'ErrorMessages'
);
